import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFlowConnectorSolid({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M2.636 15.364a1 1 0 0 1 0-1.414L13.95 2.636a1 1 0 1 1 1.414 1.414L4.05 15.364a1 1 0 0 1-1.414 0z"/>
        </svg>
    );
}

export default IconFlowConnectorSolid;
